<template>
  <div class='game-bg'>
    <el-image :src="game_header" style=" width: 100%; margin-bottom: 3%"></el-image>
    <div class='game-list'>
      <div class="game-item" v-for="game in game_list" :key='game.url'>
        <div class="el-image game-img">
          <img :src="game.url" class="el-image__inner">
          <div class="download-group">
            <a v-if="game.download_google" :href="game.download_google" target="_blank">
              <img src="../assets/img_grande/download_google.png" alt="" class="download-btn">
            </a>
            <a v-if="game.download_ios" :href="game.download_ios" target="_blank">
              <img src="../assets/img_grande/download_ios.png" alt="" class="download-btn">
            </a>
            <a v-if="game.download_aws" :href="game.download_aws" target="_blank">
              <img src="../assets/img_grande/download_aws.png" alt="" class="download-btn">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        // game_header: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/images/game_header.jpg',
        game_header: `${require('../assets/img_grande/new_game_header.jpg')}`,
        game_list: [
          {
            // url: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/game_1.png',
            url: `${require('../assets/img_grande/new_game_1.png')}`,
            download_google: 'https://play.google.com/store/apps/details?id=slots.pcg.casino.games.free.android',
            download_ios: 'https://apps.apple.com/us/app/id1404165333',
            download_aws: 'https://www.amazon.com/gp/product/B07JHXZZKS',
            name: 'CF'
          },
          {
            // url: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/game_2.png',
            url: `${require('../assets/img_grande/new_game_2.png')}`,
            download_google: 'https://play.google.com/store/apps/details?id=com.diamondlife.slots.vegas.free',
            download_ios: 'https://apps.apple.com/us/app/id1356045010',
            download_aws: 'https://www.amazon.com/gp/product/B07PFXRD9G',
            name: 'LS'
          },
          {
            // url: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/game_3.png',
            url: `${require('../assets/img_grande/df_game.png')}`,
            download_google: 'https://play.google.com/store/apps/details?id=com.grandegames.slots.dafu.casino',
            download_ios: 'https://apps.apple.com/us/app/id1356980152',
            download_aws: 'https://www.amazon.com/gp/product/B07WCW5BJZ',
            name: 'JW'
          },
          {
            // url: 'https://d105xpbtjj9cjp.cloudfront.net/officialweb/img_bole/game_4.png',
            url: `${require('../assets/img_grande/vf_game_2023.png')}`,
            download_google: 'https://play.google.com/store/apps/details?id=com.funtriolimited.slots.casino.free',
            download_ios: 'https://apps.apple.com/us/app/vegas-friends-casino-slots/id1492980232',
            download_aws: "https://www.amazon.com/gp/product/B08TZV96J5",
            name: 'VF'
          },
          {
            url: `${require('../assets/img_grande/game_jf_0324.png')}`,
            download_google: 'https://play.google.com/store/apps/details?id=slots.dcg.casino.games.free.android',
            download_ios: 'https://apps.apple.com/us/app/jackpot-crush-casino-slots/id1529572983',
            name: 'JF'
          },
          {
            url: `${require('../assets/img_grande/game_cb_1025.png')}`,
            download_google: 'https://play.google.com/store/apps/details?id=com.unicornstudio.cashparty.slots.casino.vegas.free',
            download_ios: 'https://apps.apple.com/app/id1591887467?mt=8',
            name: 'CB'
          },
          {
            url: `${require('../assets/img_grande/game_cr.png')}`,
            download_google: "https://play.google.com/store/apps/details?id=slots.acg.casino.games.free.android",
            name: 'CR'
          },
        ]
      }
    }
  }
</script>

<style lang="less">
  h1 {
    margin-top: 100px;
  }

  .game-img {
    margin-left: auto;
    margin-right: auto;
    display: block;
    margin-bottom: -6%;
    width: 70%;
  }

  .game-item {
    margin-bottom: 10%;
  }
  .download-btn {
    width: 7.5vw;
  }
  .download-group {
    width: 40%;
    position: absolute;
    bottom: 20px;
    left: 36%;
    a {
      cursor: pointer;
    }
  }

  @media screen and (max-width: 992px) {
    .game-img {
      width: 98%;
    }
    .download-group {
      width: 60%;
      position: absolute;
      bottom: 1px;
      left: 26%;
    }
    .download-btn {
      width: 13.5vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Game.vue